import request from '@/utils/request'

/**
 * 等级
 * @param {*} params token, userId
 * @returns
 */
export const cardGrade = params => {
  return request({
    method: 'post',
    url: '/cm/agent/selectMyRank',
    data: params
  })
}

/**
 * 卡数量
 * @param {*} params token, userId
 * @returns
 */
export const cardNum = params => {
  return request({
    method: 'post',
    url: '/cm/eqp/mobileQueryCard',
    data: params
  })
}
/**
 * 卡数量
 * @param {*} params token, userId
 * @returns
 */
export const userTopNum = params => {
  return request({
    method: 'post',
    url: '/mySet/myInfo/mobileIndex',
    data: params
  })
}

/**
 * 充值价格套餐查询
 * @param {*} params token, userId
 * @returns
 */
export const PriceChangeList = params => {
  return request({
    method: 'post',
    url: '/cm/service/mobileList',
    data: params
  })
}

/**
 * 充值价格查询
 * @param {*} params token, userId, packageId
 * @returns
 */
export const PriceChange = params => {
  return request({
    method: 'post',
    url: '/cm/service/mobilePrice',
    data: params
  })
}

/**
 * 充值价格修改
 * @param {*} params token, userId, packId, sale
 * @returns
 */
export const PriceChangeEdit = params => {
  return request({
    method: 'post',
    url: '/cm/service/mobileEditSale',
    data: params
  })
}

/**
 * 密码修改
 * @param {*} params token, oldPassword, newPassword, userId
 * @returns
 */
export const PasswordChange = params => {
  return request({
    method: 'post',
    url: '/mySet/myPwd/mobileEdit',
    data: params
  })
}

/**
 * 价格表
 * @param {*} params token
 * @returns
 */
export const priceTable = params => {
  return request({
    method: 'post',
    url: '/cm/priceTable/mobileList',
    data: params
  })
}

/**
 * 余额
 * @param {*} params token, userId
 * @returns
 */
export const profit = params => {
  return request({
    method: 'post',
    url: '/cm/profit/mobileBalance',
    data: params
  })
}

/**
 * 余额流水
 * @param {*} params token, userId
 * @returns
 */
export const profitList = params => {
  return request({
    method: 'post',
    url: '/cm/profit/balanceHis',
    data: params
  })
}

/**
 * 等级数量设置(显示)
 * @param {*} params token, userId
 * @returns
 */
export const rankSet = params => {
  return request({
    method: 'post',
    url: '/cm/rankSet/mobileList',
    data: params
  })
}

/**
 * 代理商
 * @param {*} params token, userId
 * @returns
 */
export const agent = params => {
  return request({
    method: 'post',
    url: '/cm/agent/mobileList',
    data: params
  })
}

/**
 * 分享
 * @param {*} params token, userId
 * @returns
 */
export const shareUrl = params => {
  return request({
    method: 'post',
    url: '/share',
    data: params
  })
}

/**
 * 个人信息(服务商资料查询)
 * @param {*} params token, userId
 * @returns
 */
export const serviceInfo = params => {
  return request({
    method: 'post',
    url: '/cm/service/mobileInfo',
    data: params
  })
}

/**
 * 个人信息(服务商资料修改)
 * @param {*} params token, userId
 * @returns
 */
export const serviceEdit = params => {
  return request({
    method: 'post',
    url: '/cm/service/mobileEdit',
    data: params
  })
}

/**
 * 个人信息(基本信息查询)
 * @param {*} params token, userId
 * @returns
 */
export const myInfo = params => {
  return request({
    method: 'post',
    url: '/mySet/myInfo/mobileInfo',
    data: params
  })
}

/**
 * 个人信息(基本信息修改)
 * @param {*} params token, userId
 * @returns
 */
export const myInfoEdit = params => {
  return request({
    method: 'post',
    url: '/mySet/myInfo/mobileEdit',
    data: params
  })
}

/**
 * 流量包订单
 * @param {*} params token, userId
 * @returns
 */
export const flowAddOrder = params => {
  return request({
    method: 'post',
    url: '/cm/flowAddOrder/mobileList',
    data: params
  })
}
/**
 * 流量包订单
 * @param {*} params token, userId
 * @returns
 */
export const flowlist = params => {
  return request({
    method: 'get',
    url: '/cm/flowAdd/flowlist',
    data: params
  })
}

/**
 * 充值订单
 * @param {*} params token, userId
 * @returns
 */
export const saleOrder = params => {
  return request({
    method: 'post',
    url: '/cm/saleOrder/mobileList',
    data: params
  })
}

/**
 * 超流量数量,已停机数量
 * @param {*} params token, userId
 * @returns
 */
export const mobileIndex = params => {
  return request({
    method: 'post',
    url: '/mobileIndex',
    data: params
  })
}

/**
 * 退出登录
 * @param {*} params token, userId
 * @returns
 */
export const signOut = params => {
  return request({
    method: 'post',
    url: '/signOut',
    data: params
  })
}

/**
 * 解绑微信
 * @param {*} params token, userId
 * @returns
 */
export const unBindWeChat = params => {
  return request({
    method: 'post',
    url: '/unBindWeChat',
    data: params
  })
}

/**
 * 手机短信验证码发送 => 解绑时候
 * @param {*} params token, userId
 * @returns
 */
export const smsSend = params => {
  return request({
    method: 'post',
    url: '/smsSend',
    data: params
  })
}

/**
 * 手机短信验证码校验 => 注册时候
 * @param {*} params account
 * @returns
 */
export const smsVerify = params => {
  return request({
    method: 'post',
    url: '/registerSmsSend',
    data: params
  })
}

/**
 * 手机短信验证码校验
 * @param {*} params token, userId
 * @returns
 */
export const getPhoneNumber = params => {
  return request({
    method: 'post',
    url: '/mySet/myInfo/selectMobile',
    data: params
  })
}
